import { ListingConfig } from "./index";

export const RefuelConfig: ListingConfig = {
  reportConfig: {
    reportId: "jfN53aWEpCBoxVzouErd",
  },
  // Defines the primary date field in the 'capturedRefuel' collection for date range filtering
  dateField: "transactionDate",
  filterConfig: [
    {
      fieldIdToFilter: "documentNumber",
      label: "Document #",
      paramName: "documentNumber",
      placeholder: "e.g. R000-000-001",
      // No sourceCollection indicates this is a text input filter
    },
    {
      // Field in the 'capturedRefuel' collection (templateName) to filter on
      fieldIdToFilter: "fleetId",
      label: "Vehicle", // Label for the Select dropdown
      paramName: "vehicle", // URL query parameter name
      sourceCollection: "fleet", // Firestore collection to fetch options from
      // sourceFieldForValue: "id", // Implicitly use document ID as the value
      sourceFieldForLabel: "name", // Field in 'fleet' documents for the dropdown label (e.g., vehicle name/registration)
    },
    {
      fieldIdToFilter: "driverId",
      label: "Driver",
      paramName: "driver",
      sourceCollection: "fleetOperators",
      // sourceFieldForValue: "id", // Implicitly use document ID
      sourceFieldForLabel: "fullName", // Field in 'fleetOperators' documents for the dropdown label
    }
  ],
  fieldConfig: {
    deviceCaptured: { label: "Device Captured", tableRank: -1, detailsRank: -1, editable: false, type: "DATE" },
    gpsLocation: { label: "Location", tableRank: -1, detailsRank: 3, editable: false, type: "COORDINATE" },
    transactionDate: { label: "Date", tableRank: 1, detailsRank: 0, editable: true, type: "DATE" }, // This is the dateField
    driverOperator: { label: "Fleet operator", tableRank: -1, detailsRank: 1, editable: false, type: "STRING" },
    driverOperatorSignedImage: { label: "Operator signature", tableRank: -1, detailsRank: 1, editable: false, type: "IMAGE" },
    pumpPhoto: { label: "Operator signature", tableRank: -1, detailsRank: 1, editable: false, type: "IMAGE" },
    slipPhoto: { label: "Receipt photo", tableRank: -1, detailsRank: 1, editable: false, type: "IMAGE" },
    litres: { label: "Litres", tableRank: 2, detailsRank: 1, editable: true, type: "NUMBER" },
    activityName: { label: "Activity", tableRank: -1, detailsRank: -1, editable: false, type: "STRING" },
    activityId: {
      label: "Activity",
      tableRank: -1,
      detailsRank: 4,
      editable: true,
      type: "SELECT",
      sourceCollection: "activities",
      sourceFieldForLabel: "name",
      adjacentFields: {
        activityName: "name",
        activityRebateEligiable: "rebateEligible",
      }
    },
    activityRebateEligiable: { label: "Rebate eligible", tableRank: -1, detailsRank: 4, editable: false, type: "STRING" },
    areaForFleetUseFarmName: { label: "Area name", tableRank: -1, detailsRank: 7, editable: false, type: "STRING" },
    areaForFleetUseFarmId: {
      label: "Area/Zone",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "SELECT",
      sourceCollection: "areaForFleetUse",
      sourceFieldForLabel: "zoneName",
    },
    areaForFleetUseSizeHectares: { label: "Area size", tableRank: -1, detailsRank: 7, editable: false, type: "STRING" },
    areaforFleetUseName: { label: "Section name", tableRank: -1, detailsRank: 8, editable: false, type: "STRING" },
    areaForFleetUseId: {
      label: "Section",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "SELECT",
      sourceCollection: "sections",
      sourceFieldForLabel: "sectionName",
    },
    driverId: { 
      label: "Driver", 
      tableRank: -1, 
      detailsRank: 1, 
      editable: true, 
      type: "SELECT",
      sourceCollection: "fleetOperators",
      sourceFieldForLabel: "fullName",
      adjacentFields: {
        driverOperator: "fullName",
        driverEmployeeCode: "employeeCode",
        driverIdentification: "identification",
        driverNameAndSurname: "fullName",
        driverNickName: "nickName"
      }
    },
    driverEmployeeCode: { label: "Operator employee code", tableRank: -1, detailsRank: 1, editable: false, type: "STRING" },
    driverIdentification: { label: "Operator ID", tableRank: -1, detailsRank: 1, editable: false, type: "STRING" },
    driverNameAndSurname: { label: "Operator name", tableRank: -1, detailsRank: -1, editable: false, type: "STRING" },
    driverNickName: { label: "Operator nickname", tableRank: -1, detailsRank: 1, editable: false, type: "STRING" },
    odoOrHourReadingPhoto: { label: "ODO photo", tableRank: -1, detailsRank: 1, editable: false, type: "IMAGE" },
    odoOrHourReading: { label: "ODO", tableRank: 4, detailsRank: 1, editable: true, type: "NUMBER" },
    fuelType: { label: "Fuel type", tableRank: -1, detailsRank: 1, editable: false, type: "STRING" },
    productName: { label: "Product", tableRank: -1, detailsRank: -1, editable: false, type: "STRING" },
    productId: {
      label: "Product",
      tableRank: -1,
      detailsRank: 5,
      editable: true,
      type: "SELECT",
      sourceCollection: "products",
      sourceFieldForLabel: "name",
      adjacentFields: {
        productName: "name",
      }
    },
    fleetId: { 
      label: "Vehicle", 
      tableRank: -1, 
      detailsRank: 1, 
      editable: true, 
      type: "SELECT",
      sourceCollection: "fleet",
      sourceFieldForLabel: "name",
      adjacentFields: {
        fleetDescription: "description",
        fleetDisplayName: "name",
        fleetOdoOrHourBased: "measurementUnit",
        fleetRegistration: "registrationNumber",
        fleetUseFleetForRebateClaim: "useForRebateClaim"
      }
    },
    fleetDefaultActivity: { label: "FleetDefaultActivity", tableRank: -1, detailsRank: -1, editable: false, type: "STRING" },
    fleetDescription: { label: "FleetDescription", tableRank: -1, detailsRank: -1, editable: false, type: "STRING" },
    fleetDisplayName: { label: "Vehicle", tableRank: 2, detailsRank: -1, editable: false, type: "STRING" },
    fleetGroupName: { label: "Vehicle group", tableRank: -1, detailsRank: 1, editable: false, type: "STRING" },
    fleetOdoOrHourBased: { label: "FleetOdoOrHourBased", tableRank: -1, detailsRank: -1, editable: false, type: "STRING" },
    fleetPreviousFillingDate: { label: "FleetPreviousFillingDate", tableRank: -1, detailsRank: -1, editable: false, type: "STRING" },
    fleetRegistration: { label: "Vehicle registration", tableRank: 5, detailsRank: 1, editable: false, type: "STRING" },
    fleetUseFleetForRebateClaim: { label: "FleetUseFleetForRebateClaim", tableRank: -1, detailsRank: -1, editable: false, type: "BOOLEAN" },
    fillingStationName: { label: "Filling station", tableRank: -1, detailsRank: 1, editable: true, type: "STRING" },
    totalPurchasePrice: { label: "Total price", tableRank: -1, detailsRank: 0, editable: true, type: "NUMBER" },
    tripSheetNumber: { label: "Trip sheet", tableRank: -1, detailsRank: 3, editable: true, type: "STRING" },
    // purchaseOrderNumber: {label: "Purchase order",tableRank: -1, detailsRank: 3, editable: true, type: "STRING"},
    transactionReviewed: { label: "Reviewed", tableRank: -1, detailsRank: -1, editable: false, type: "BOOLEAN" },
    isModified: {
      label: "Entry modified",
      tableRank: -1,
      detailsRank: 129,
      editable: false,
      type: "BOOLEAN",
    },
    documentNumber: {
      label: "Document #",
      tableRank: 3,
      detailsRank: 100,
      editable: false,
      type: "STRING",
    },
  }
}

